import React from 'react';
import { default as Breadcrumbs } from '@jetshop/ui/Breadcrumbs';
import { styled } from 'linaria/react';
import { theme } from '../Theme';

const BreadcrumbsWrapper = styled('div')`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 2px;
  font-family: ${theme.fonts.primary};
  ul {
    margin: 0;
    justify-content: flex-start;
  }
  li,
  a {
    color: #000 !important ;
    text-decoration: none;
    font-size: 10px;
    line-height: 16px;
  }
  li {
    ::after {
      content: '>';
    }
  }

  li:last-of-type {
    ::after {
      content: '';
    }
  }
`;

export const StyledBreadcrumbs = ({ breadcrumbText, breadcrumbs, parents }) => {
  const breadcrumbProps = {
    breadcrumbText,
    breadcrumbs,
    parents
  };
  return (
    <BreadcrumbsWrapper className="breadcrumbs">
      <Breadcrumbs {...breadcrumbProps} />
    </BreadcrumbsWrapper>
  );
};
